import { notificationsConfig as config } from '../../shared/constants';

export const getShownNotifications = ({ notifications, mode, onlyUnread }) => {
  if (mode === config.all.name) {
    return onlyUnread
      ? notifications.filter((notification) => notification.isNew)
      : notifications;
  }

  return notifications.filter(
    (notification) =>
      notification.mode === mode && (onlyUnread ? notification.isNew : true)
  );
};
